import { Link } from "react-router-dom";

const friendlyLinks = [
  "影视资讯站",
  "剧集讨论区",
  "影评社区",
  "作品资料库",
  "新片速递",
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-movie-2-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">
                17C<span className="text-accent-400">.COM</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              17C.COM 是面向影视爱好者的综合影视门户，提供最新电影电视剧资讯、影评与影视作品分类浏览，帮助用户轻松发现心仪的影视内容。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100">
                <i className="ri-wechat-line text-lg" aria-hidden="true" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100">
                <i className="ri-weibo-line text-lg" aria-hidden="true" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100">
                <i className="ri-mail-line text-lg" aria-hidden="true" />
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/category/movie" className="text-background-200 transition-colors hover:text-accent-400">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-background-200 transition-colors hover:text-accent-400">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="text-background-200 transition-colors hover:text-accent-400">综艺频道</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              服务支持
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/news" className="text-background-200 transition-colors hover:text-accent-400">影视资讯</Link></li>
              <li><Link to="/search" className="text-background-200 transition-colors hover:text-accent-400">搜索影视</Link></li>
              <li><Link to="/favorites" className="text-background-200 transition-colors hover:text-accent-400">我的收藏</Link></li>
              <li><Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              友情链接
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {friendlyLinks.map((link) => (
                <span
                  key={link}
                  className="rounded-md bg-primary-800 px-3 py-1.5 text-xs text-background-200"
                >
                  {link}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© 2026 17C.COM 影视门户 · 本站影视资源与资讯均为演示内容</p>
          <p className="flex flex-wrap items-center justify-center gap-4">
            <span>内容仅供展示学习</span>
            <span>联系我们：contact@17c-demo.com</span>
          </p>
        </div>
      </div>
    </footer>
  );
}